import { Inventory, InventoryApi } from '@cibo/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { INVENTORIES_QUERY_KEYS } from './queryKeys'

export const useCreateInventory = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (name: string) => InventoryApi.createInventory(name).then(d => d.data.item),
    onSuccess: (data: Inventory) => {
      queryClient.invalidateQueries([INVENTORIES_QUERY_KEYS.INVENTORIES])
      queryClient.setQueryData([INVENTORIES_QUERY_KEYS.DETAIL, data.inventoryId], data)
    },
  })
}
